import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import {Translate} from 'views/module';

const ClientLeadEditName = (props) => {
  const {
    oldData,
    newData,
  } = props;

  const oldClientLeadName = oldData.clientLeadName;
  const newClientLeadName = newData.clientLeadName;

  return (
    <Stack>
      <Translate
        expression='clientLead.ClientLeadDetail.Correspondance.Logs.EditName.Text'
        substitute={{
          oldClientLeadName,
          newClientLeadName,
        }}
      />
    </Stack>
  );
};
ClientLeadEditName.propTypes = {
  oldData: PropTypes.object.isRequired,
  newData: PropTypes.object.isRequired,
};

export default React.memo(ClientLeadEditName);
